import React, { ReactNode } from 'react';

import { StyledFormGroup } from './styles';

interface FormGroupProps {
    id?: string;
    errors?: boolean;
    children: ReactNode;
    calloutErrorBorder?: boolean;
    className?: string;
}

const FormGroup = ({ id, errors, children, className, calloutErrorBorder }: FormGroupProps) => {
    return (
        <StyledFormGroup
            className={className}
            id={id}
            $errors={errors ? errors : undefined} // to fix styled components warning
            $calloutErrorBorder={calloutErrorBorder}
        >
            {children}
        </StyledFormGroup>
    );
};

export default FormGroup;
